import { useTransportMutation, useTransportQueryUtils } from "@/transport"
import { useQueryClient } from "@tanstack/react-query"

import { invalidateHomeQueries } from "@/lib/home-query-cache"

import { useInvalidateTestSetTransportQueries } from "./useTestSetsTransport"

export function useDeleteTestSetsTransport() {
  const invalidateTestSets = useInvalidateTestSetTransportQueries()
  const queryUtils = useTransportQueryUtils()
  const queryClient = useQueryClient()

  return useTransportMutation("deleteTestSets", {
    onMutate: () => ({ invalidateTestSets, queryUtils }),
    onSettled: (_data, _error, _variables, context) => {
      if (_error || !context) {
        return
      }
      void context.invalidateTestSets()
      void context.queryUtils.invalidateOperation("listRecentlyDeletedTestSets")
      void invalidateHomeQueries(queryClient)
    },
  })
}
